<template>
  <el-form label-position="top" :model="ruleForm">
    <el-form-item label="Level">
      <el-select
        v-model="ruleForm.level"
        multiple
        placeholder="Level"
        clearable
        style="width:100%"
      >
        <el-option label="LOW" value="0"></el-option>
        <el-option label="MEDIUM" value="1"></el-option>
        <el-option label="HIGH" value="2"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="Devices">
      <SmartSelect
        v-model="ruleForm.deviceKey"
        :load-method="getAllAssetVo"
        value-field="deviceKey"
        display-field="name"
        multiple
        placeholder="Select event sources..."
        ref="deviceRef"
        value-type="Array<number>"
        style="width: 100%"
      />
    </el-form-item>
  </el-form>
</template>
<script>
import SmartSelect from "@/components/SmartControls/SmartSelect.vue";
import SmartInfiniteCursorScroll from "./SmartInfiniteCursorScroll.vue";
import { getAllAssetVo } from "@/api";

export default {
  name: "CameraAlertParams",
  components: {
    SmartSelect,
    SmartInfiniteCursorScroll,
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      ruleForm: this.value
        ? { ...this.value }
        : {
            deviceKey: [],
            level: [],
          },
    };
  },
  watch: {
    value: {
      handler(v) {
        if (v) this.ruleForm = v;
      },
      deep: true,
    },
    ruleForm: {
      handler(v) {
        this.$emit("input", v);
      },
      deep: true,
    },
  },
  methods: {
    getAllAssetVo,
    handleDeviceCheck(id, checked) {
      if (!Array.isArray(this.ruleForm.deviceId)) this.ruleForm.deviceId = [];
      const arr = this.ruleForm.deviceId;
      const idx = arr.indexOf(id);
      if (checked && idx === -1) {
        arr.push(id);
      } else if (!checked && idx !== -1) {
        arr.splice(idx, 1);
      }
    },
  },
};
</script>
